(function(){

	// Import class
	var State = include("springroll.State"),
		Sound = include("springroll.Sound");

	/**
	*  The logic for the title state
	*  @class heist.CutsceneState
	*  @extends springroll.State
	*/
	var CutsceneState = function(options)
	{
		// For the inheritence
		State.call(this, new heist.CutscenePanel(), options);
		
		this._usedPaintings = null;

		// Bind the handler
		this._onSkipClick = this._onSkipClick.bind(this);
		this._onSkipOver = this._onSkipOver.bind(this);
		this._onCutsceneEnded = this._onCutsceneEnded.bind(this);
		
		this.on("loading", this.onLoading);
		this.on("loaded", this.onLoaded);
	};

	// Super prototype
	var s = State.prototype;

	// Extend the ManifestState class
	var p = CutsceneState.prototype = Object.create(s);

	p.enter = function()
	{
		s.enter.call(this);
		//stop music for the cutscene
		this.app.music = null;
		//mark the application as not skipped
		this.app.cutsceneSkipped = false;
	};
	
	p.onLoading = function(assets)
	{
		this.cutsceneAsset = this.app.config.cutscenes[this.app.cutsceneData.cutscene];
		assets.push(this.cutsceneAsset);
	};

	p.onLoaded = function()
	{
		this.panel.setup();
		
		var app = this.app;
		
		this.cutscene = this.app.getCache(this.cutsceneAsset.id);
		
		var display = this.app.getDisplay("cutscene");
		display.stage.addChild(this.cutscene);
		
		var _clip = this.cutscene._clip;
		//Check for frames that should be stopped on
		if(_clip.clueletter)
		{
			_clip.clueletter.gotoAndStop(app.currentCrimeConfig.letter);
		}
		else if(_clip.newspaper)
		{
			var newspaper = _clip.newspaper;
			//set suspect
			newspaper.thief.gotoAndStop(app.currentCrimeConfig.thief);
			//set art, preventing duplicates
			var painting = newspaper.painting;
			var totalFrames = painting.timeline.duration;
			if(!this._usedPaintings)
				this._usedPaintings = [];
			//gather the options available for use
			var options = [];
			for(var i = 0; i < totalFrames; ++i)
			{
				if(this._usedPaintings.indexOf(i) == -1)
					options.push(i);
			}
			//pick a valid option
			var rand = options.random();
			//if we are about to use the last painting, reset the list
			if(this._usedPaintings.length == totalFrames - 1)
				this._usedPaintings.length = 0;
			//add the painting so we can't use it next time
			this._usedPaintings.push(rand);
			//have the art display the chosen painting
			painting.gotoAndStop(rand);
		}
		
		var button = this.panel.skipButton;
		button.on("buttonPress", this._onSkipClick);
		button.on("mouseover", this._onSkipOver);
		
		display.visible = true;
		display.paused = false;
		display.render(0);//do a single render so canvas isn't empty behind transition
		display.paused = true;//then pause rendering
	};
	
	p.enterDone = function()
	{
		//start playing the cutscene
		this.cutscene.start(this._onCutsceneEnded);
		
		this.app.getDisplay("cutscene").paused = false;
	};
	
	p._onSkipOver = function()
	{
		Sound.instance.play("SFX_ButtonHover");
	};

	/**
	*  Handler when the skip button is clicked
	*  @method _onSkipClick
	*/
	p._onSkipClick = function()
	{
		var app = this.app;
		var data = app.cutsceneData;
		if(data.skipLabel)
			app.trackEvent(["Skipped", data.skipLabel,
							Math.round(this.cutscene._elapsedTime * 1000)]);
		//mark the cutscene as skipped so the following state can take it into account
		//if relevant
		app.cutsceneSkipped = true;
		
		Sound.instance.play("SFX_ButtonClick");
		this.cutscene.stop();
		this._onCutsceneEnded();
	};
	
	p._onCutsceneEnded = function()
	{
		var button = this.panel.skipButton;
		button.off("buttonPress", this._onSkipClick);
		button.off("mouseover", this._onSkipOver);
		//go to whatever state is next
		this.manager.state = this.app.cutsceneData.nextState;
	};

	/**
	*  When the state exists
	*  @method exit
	*/
	p.exit = function()
	{
		this.panel.teardown();
		
		s.exit.call(this);
		
		this.app.unload(this.cutsceneAsset.id);
		//wrap stuff in if checks in case the game is destroyed during the load process
		this.cutscene = this.cutsceneAsset = null;
		//Nuke lib and images
		window.lib = {};
		window.images = {};
			
		s.exit.call(this);
	};

	// Assign to the namespace
	namespace('heist').CutsceneState = CutsceneState;

}());